import { EXCLUDED_PATHS } from "./REDIRECT_EXCLUDED";

export const emailPattern = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

//eslint-disable-next-line
export const multipleEmailsPattern = /^(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,4}|[0-9]{1,3})(\]?)(\s*(;)\s*|\s*$))*$/;

const priceInputPattern = /^[0-9]+(\.)?([0-9]{1,2})?$/;

export const phonePattern = /^[+]?[0-9]+$/;

export const isEmailValid = (email: string): boolean => {
    if (email?.length >= 5) {
        return emailPattern.test(email);
    } else return false;
};

export function bytesToHumanReadable(bytes, decimals = 2) {
    if (!+bytes) return '0 B'

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['B', 'kB', 'MB', 'GB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
};

export const isPriceValid = (price: string): boolean => {
    return priceInputPattern.test(price);
};

export const stringComparator = (a: string, b: string) => {
    return a?.toUpperCase() > b?.toUpperCase() ? 1 : -1;
};

export const redirectToPrevious = (redirectLogin: string): boolean => {
    return redirectLogin !== "null" && !EXCLUDED_PATHS.some(path => redirectLogin.includes(path));
};

export function createTarget(name, value) {
    return {
        target: {
            name: name,
            value: value
        }
    };
}

export const searchCaseInsensitive = (term: string, searchString: string) => {
    if (!searchString || !term) return false;
    return searchString?.toLowerCase().indexOf(term?.toLowerCase()) !== -1;
}